import { Badge, BadgeProps } from "@mantine/core"

import { Label } from "../../atoms/Label/Label"
import { Missing } from "../Missing/Missing"

type Props = {
  value?: string | null
} & BadgeProps

export const CodeCell = ({ value, ...props }: Props) =>
  value ? (
    <Badge
      {...props}
      color="secondary"
      autoContrast={false}
      size="xs"
      w="fit-content"
    >
      <Label label={value} />
    </Badge>
  ) : (
    <Missing />
  )
